import { initMap } from 'allink-core-static/js/modules/map';

$(function(){

    var options = {
        // define options here
    };

    initMap(options);

});



// WEBPACK FOOTER //
// ./static/js/modules/map.js